import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { getTheme } from "config/styles/getTheme";
import Mainpage from "pages/main";
import ForceReload from "pages/force-redirect";
// import HaiIframe from "pages/hai";

function App() {
  return (
    <React.Suspense fallback={null}>
      <div className="App">
        <ThemeProvider theme={getTheme()}>
          <ErrorBoundary FallbackComponent={() => <div>Error loading</div>}>
            <BrowserRouter>
              <Routes path="/" element={<Mainpage />}>
                <Route index element={<Mainpage />} />
                {/* <Route path="hai" element={<HaiIframe />} /> */}
                <Route path="hai" element={<ForceReload />} />
              </Routes>
            </BrowserRouter>
          </ErrorBoundary>
        </ThemeProvider>
      </div>
    </React.Suspense>
  );
}

export default App;
